const markup = `# H1
## H2
Horizontal line :
- - - -
[I'm an inline-style link](https://www.google.com)

Inline \`code\` has \`back-ticks around\` it.

\`\`\`javascript
var s = "JavaScript syntax highlighting";
alert(s);
\`\`\`
> Blockquote
>> Nested Blockquote

Image with alt :

![alt text](https://github.com/adam-p/markdown-here/raw/master/src/common/images/icon48.png "Logo Title Text 1")

__Strong text__ or **Strong text**

* Bullet list
  * Nested bullet
    * Sub-nested bullet etc
* Bullet list item 2`;

export default markup;
